import { createSlice } from '@reduxjs/toolkit';

import { IInitialSiteListState } from './types';

const SLICE_NAME = 'SITE_LIST_SLICE';

const initialState: IInitialSiteListState = {
  data: [],
  loading: true,
  error: null,
  loadinglastSiteAudited : false,
  lastSiteAuditedError : "",
  lastSiteAuditedData : null,
  deleted : false,
  siteError : "",
  siteAdded : false,
  companysitelist: null,
  companysitelisterror: '',
  companysitelistloading: false,
  lastestSiteAdded: null
};

const siteListSlice = createSlice({
  name: SLICE_NAME,
  initialState: initialState,
  reducers: {
    fetchSiteListError: (state , { payload }) => {
      state.loading = false;
      state.error = payload;
    },
    fetchSiteList: (state , { payload })=> {
      state.loading = true;
    },
    fetchSiteListSuccess: (state, { payload }) => {
      state.data = [];
      state.loading = false;
      state.data[payload.id] = payload.result;
    },
    addSiteList: (state, { payload }) => {
      state.loading = true;
    },
    addSiteListSuccess: (state,{ payload }) => {
      state.siteError = '',
      state.loading = false;
      state.siteAdded = true;
      state.lastestSiteAdded = payload;
    },

    addSiteLisError: (state , { payload }) => {
      state.siteError = payload
      state.loading = false;
    },
    _updateAdSiteList: (state) => {
      state.siteError = ""
      state.loading = false;
      state.siteAdded = false;
    },
    removeSiteList: (state, { payload }) => {
      state.loading = true;
    },
    removeSiteSuccess: (state) => {
      state.loading = true; 
      state.lastSiteAuditedData = null;
      state.deleted = true;
    },
    updateremoveSite: (state) => {
      state.deleted = false;
      state.error = ""
    },

    getLastWebsiteAuditSuccess: (state , { payload }) => {
      state.loadinglastSiteAudited = true;
      state.lastSiteAuditedError = '';
      state.lastSiteAuditedData = payload;
    },
    getLastWebsiteAudit: (state) => {
      state.loadinglastSiteAudited = false;
      state.lastSiteAuditedError = '';
    },
    getLastWebsiteAuditError: (state , { payload }) => {
      state.loadinglastSiteAudited = false;
      state.lastSiteAuditedError = payload;
    },

    fetchCompanySiteListError: (state , { payload }) => {
      state.companysitelistloading = false;
      state.companysitelisterror = payload;
    },
    fetchCompanySiteList: (state,{payload=''}) => {
      state.companysitelistloading = true;
    },
    fetchCompanySiteListSuccess: (state, { payload }) => {
      state.companysitelistloading = false;
      state.companysitelist = payload;
    },
  },
});

export default siteListSlice;
